import React from 'react';
import { Link } from 'react-router-dom';

// Import Styles
import '../../design/styles/footer-home.scss';

const FooterHome = () => {
    return (
        <footer className="footer-home">
            <div className="content">
                <ul className="opts">
                    <li>
                        <span>©2025 Todos los derechos reservados</span>
                    </li>
                    <li>
                        <a href="/files/aviso-de-privacidad.pdf" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>
                    </li>
                    <li>
                        <a href="/files/terminos-y-condiciones.pdf" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>
                    </li>
                    <li>
                        <a href="/files/datos-personales.pdf" target="_blank" rel="noopener noreferrer">Protección de Datos</a>
                    </li>
                    <Link to={'/contacto'}>
                        <span>Contáctanos</span>
                    </Link>
                </ul>
            </div>
        </footer>
    );
}

export default FooterHome;